const MAIN_INFO_FIELDS = [
  {
    keys: ["bussinessInfo", "businessInfo", "businessOverview"],
    question: "Please provide a brief overview of your business or brand?",
  },
  {
    keys: ["productsOrServices", "productsServices"],
    question: "What are your primary products or services?",
  },
  {
    keys: ["targetAudience"],
    question: "Who is your target audience?",
  },
  {
    keys: ["goalsAndResults", "objectives"],
    question: "What are your main objectives for this project and what results would you like to achieve?",
  },
  {
    keys: ["service", "services"],
    question: "Which service(s) are you interested in?",
  },
  {
    keys: ["notes", "additionalInfo"],
    question: "Is there anything else you would like us to know about your project, notes, or requirements?",
  },
];

const formatAnswerValue = (value) => {
  if (value === undefined || value === null) return "";
  if (Array.isArray(value)) return value.filter(Boolean).join(", ");
  return String(value).trim();
};

const pickMainInfoValue = (mainInfo, keys) => {
  for (const key of keys) {
    const value = formatAnswerValue(mainInfo?.[key]);
    if (value) return value;
  }
  return "";
};

export const buildAnswersFromMainInfo = (mainInfo = {}) =>
  MAIN_INFO_FIELDS.map(({ keys, question }) => {
    const answer = pickMainInfoValue(mainInfo, keys);
    if (!answer) return null;
    return { question, answer };
  }).filter(Boolean);

const normalizeAnswerItem = (item) => {
  if (!item || typeof item !== "object") {
    const text = formatAnswerValue(item);
    return text ? { question: "", answer: text } : null;
  }

  const question = formatAnswerValue(
    item.question ?? item.q ?? item.label ?? item.key ?? item.title
  );
  const answer = formatAnswerValue(
    item.answer ?? item.a ?? item.value ?? item.response ?? item.text
  );

  if (!question && !answer) return null;
  return {
    question: question || "Question",
    answer,
  };
};

export const normalizeBrief = (b = {}) => {
  const sender = b.sender || {};
  const mainInfo = b.mainInfo || b.main_info || {};

  const name =
    formatAnswerValue(b.name) ||
    formatAnswerValue(sender.fullName) ||
    formatAnswerValue(sender.name) ||
    formatAnswerValue(b.fullName) ||
    [sender.firstName, sender.lastName].map(formatAnswerValue).filter(Boolean).join(" ") ||
    [b.firstName, b.lastName].map(formatAnswerValue).filter(Boolean).join(" ");

  const company =
    formatAnswerValue(b.company) ||
    formatAnswerValue(sender.brand) ||
    formatAnswerValue(sender.company) ||
    formatAnswerValue(b.brand);

  const email = formatAnswerValue(b.email) || formatAnswerValue(sender.email);
  const phone = formatAnswerValue(b.phone) || formatAnswerValue(sender.phone);

  const existingAnswers = Array.isArray(b.answers)
    ? b.answers.map(normalizeAnswerItem).filter(Boolean)
    : [];

  const answers =
    existingAnswers.length > 0
      ? existingAnswers
      : buildAnswersFromMainInfo(mainInfo);

  return {
    _id: b._id || b.id,
    name,
    email,
    phone,
    company,
    department: formatAnswerValue(b.department),
    status: formatAnswerValue(b.status) || "NEW",
    answers,
    createdAt: b.createdAt || b.created_at || new Date().toISOString(),
  };
};
